"use client";
import React, { useRef, useState, useEffect } from "react";
import styles from "./CareerWithAptech.module.scss";
import downloadArrow from "../../assets/images/downloadArrow.png";
import location from "../../assets/images/location.png";
import CareerCard from "../CustomComponent/CareerCard.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";
import axios from "axios";
import DOMPurify from "dompurify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CareerWithAptech: React.FC = () => {
  const [careers, setCareers] = useState<any[]>([]);

  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Careers with Aptech", link: "" },
  ];

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/careers/getlist`); // 🔁 replace with actual API
        setCareers(res.data?.Careers || []);
      } catch (err) {
        console.error("Error fetching careers", err);
      }
    };

    fetchCareers();
  }, []);

  return (
    <div id="CareerWithAptech" className={styles.CareerWithAptech}>
      <BreadCrumb menu={breadcrumb} />

      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <Banner />
          <BannerTwo />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <VacanciesSection careers={careers} />
        </motion.div>
      </div>
    </div>
  );
};

const Banner = () => {
  const content = [
    `Education is a dynamic industry focused on empowering individuals through knowledge delivery and skill development. Aptech is proud to be at the forefront of this sector in the 21st century.`,
    `Working at Aptech is an enriching and enjoyable experience. Here, challenges are balanced by rewards, achievements, and employee satisfaction.`,
  ];

  return (
    <div className="section">
      <div className="row mt-5">
        <div className="col-12">
          <ImageTextSection
            imageSrc={"/images/creative-team-discussing-hologram-project.png"}
            imageAlt="Creative Team"
            imageTitle="Creative Team"
            content={content}
            heading="Careers with Aptech"
            reverse={true}
            imageHeight={`25rem`}
            imageHeightTablet={`25rem`}
          />
        </div>
      </div>
    </div>
  );
};

const BannerTwo = () => {
  const contentTraining = [
    `Aptech has been in the vocational skill-training business in India for more than three decades.`,
    `Aptech recruits for positions such as sales, marketing, faculty, HR, IT, etc.`,
  ];

  return (
    <div className="section">
      <div className="row">
        <div className="col-12">
          <ImageTextSection
            imageSrc={"/images/corporate-trainer-conducting-workshop.png"}
            imageAlt="Workshop"
            imageTitle="Workshop"
            content={contentTraining}
            heading="Vocational skill-training business in India"
            isMobileReverse={true}
            imageAlign="center"
            imageHeightTablet={`25rem`}
            imageHeight={`25rem`}
          />
        </div>
      </div>
    </div>
  );
};

const VacanciesSection = ({ careers }: { careers: any[] }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [selectedCareer, setSelectedCareer] = useState<any>(null);

  const handleShowModal = (career: any) => {
    setSelectedCareer(career);

    if (modalRef.current) {
      const bootstrap = require("bootstrap");
      const modalInstance = bootstrap.Modal.getInstance(modalRef.current);

      if (modalInstance) modalInstance.hide();

      const modal = new bootstrap.Modal(modalRef.current);
      modal.show();
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <p className="heading">Careers with Aptech</p>
          <p className="para">Aptech is always looking for talented people.</p>
        </div>
      </div>

      <div className="row">
        {careers.length > 0 ? (
          careers.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-12 mt-3" key={index}>
              <CareerCard
                downloadArrow={downloadArrow}
                title={item.title}
                subTitle={item.location}
                handleShowModal={() => handleShowModal(item)}
              />
            </div>
          ))
        ) : (
          <p className="para">No vacancies available</p>
        )}
      </div>

      {/* Modal */}
      <div className="modal fade" ref={modalRef} tabIndex={-1}>
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className={`modal-content ${styles.modalContent}`}>
            <div className="modal-header">
              <p className="heading mb-0">{selectedCareer?.title}</p>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              {selectedCareer && (
                <>
                  <div className="d-flex align-items-center mb-3">
                    <img src={location} width="40" height="40" />
                    <p className="para ms-2">
                      Location: {selectedCareer.location}
                    </p>
                  </div>

                  {selectedCareer && selectedCareer?.brief_job_description && (
                    <>
                      <p className="heading3">Brief Job Description: </p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            selectedCareer.brief_job_description || "",
                          ),
                        }}
                      />
                    </>
                  )}

                  {selectedCareer &&
                    selectedCareer?.desired_candidate_profile && (
                      <>
                        <p className="heading3 mt-3">
                          Desired Candidate Profile:{" "}
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              selectedCareer.desired_candidate_profile || "",
                            ),
                          }}
                        />
                      </>
                    )}

                  {selectedCareer && selectedCareer?.required_skill_set && (
                    <>
                      <p className="heading3 mt-3">Required Skill Set: </p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            selectedCareer.required_skill_set || "",
                          ),
                        }}
                      />
                    </>
                  )}

                  {selectedCareer && selectedCareer?.soft_skills && (
                    <>
                      <p className="heading3 mt-3">Soft Skills: </p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            selectedCareer.soft_skills || "",
                          ),
                        }}
                      />
                    </>
                  )}

                  <a
                    href={`mailto:${selectedCareer.apply_to}?subject=Ref: Application for ${selectedCareer.title}`}
                    className={styles.link}
                  >
                    <div className={styles.buttonDiv}>
                      <p className="secondary-btn">Apply for this position</p>
                    </div>
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="section mt-4">
        {/*
          <h4>Please contact Rashmi/Priyanka in HR for further details.</h4>
          <div className={styles.ContactUs}>
            <a href="tel:+912268282300">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 25 27" fill="none">
            <path d="M18.6641 26.0207C17.6349 26.021 16.6235 25.7525 15.7301 25.2417L15.6041 25.1707C9.79523 21.8478 4.93547 17.091 1.48905 11.3547L0.83205 10.2597C0.159142 9.14019 -0.119697 7.82769 0.0399677 6.53134C0.199633 5.23499 0.788614 4.02939 1.71305 3.10666L3.02205 1.79766C4.12205 0.697656 5.91105 0.697656 7.01005 1.79766L9.89405 4.68166C10.3281 5.11774 10.6082 5.68339 10.6919 6.29293C10.7756 6.90247 10.6584 7.5227 10.358 8.05966L9.27405 9.98466C9.25127 10.0252 9.24236 10.072 9.24868 10.118C9.255 10.1641 9.2762 10.2068 9.30905 10.2397L15.7301 16.6607C15.7634 16.6934 15.8065 16.7144 15.8529 16.7205C15.8992 16.7266 15.9463 16.7176 15.9871 16.6947L17.909 15.6117L17.9101 15.6107C18.4471 15.3106 19.0672 15.1936 19.6767 15.2773C20.2862 15.361 20.8518 15.6409 21.2881 16.0747L24.173 18.9607C25.2731 20.0607 25.2731 21.8497 24.173 22.9487L22.8061 24.3147C22.2616 24.8573 21.6156 25.2872 20.9049 25.58C20.1942 25.8727 19.4327 26.0225 18.6641 26.0207ZM5.01605 2.97266C4.80605 2.97266 4.59605 3.05266 4.43605 3.21266L3.12705 4.52066C2.51862 5.12799 2.13096 5.92149 2.02585 6.77472C1.92074 7.62795 2.10422 8.49181 2.54705 9.22866L3.20405 10.3237C6.4732 15.7654 11.083 20.2781 16.5931 23.4307L16.7191 23.5017C18.2451 24.3747 20.1651 24.1277 21.3911 22.8997L22.7581 21.5337C22.8342 21.4575 22.8947 21.3671 22.9359 21.2676C22.9772 21.1681 22.9984 21.0614 22.9984 20.9537C22.9984 20.8459 22.9772 20.7393 22.9359 20.6397C22.8947 20.5402 22.8342 20.4498 22.7581 20.3737L19.8731 17.4877C19.7461 17.3614 19.5814 17.2801 19.404 17.2559C19.2266 17.2317 19.0462 17.266 18.8901 17.3537L16.9681 18.4367C16.5466 18.6726 16.0598 18.7648 15.5813 18.6993C15.1027 18.6338 14.6586 18.4142 14.3161 18.0737L7.89505 11.6527C7.55419 11.3105 7.33429 10.8665 7.26878 10.3881C7.20326 9.90959 7.2957 9.4228 7.53205 9.00166L8.61605 7.07766C8.70314 6.92149 8.73707 6.74123 8.71272 6.56409C8.68837 6.38694 8.60705 6.22253 8.48105 6.09566L5.59605 3.21266C5.51994 3.13643 5.42952 3.076 5.32999 3.03481C5.23045 2.99362 5.12377 2.9725 5.01605 2.97266Z" fill="var(--primary)"></path></svg>
            <span className={styles.info}> +91 22-68282300 </span>
            </a>
            </div>
          */}
        {/*<p className="para">There are currently no active vacancies. Please check back later for updates on new opportunities at Aptech.</p>*/}
      </div>
    </div>
  );
};

export default CareerWithAptech;
